module.exports = __webpack_public_path__ + "static/media/logo-kambria-token.e344ff3c.svg";